import { combineReducers } from "redux";
import sectorReducer from "./sectorReducer";
import listadoReducer from "./listadoReducer";

export default combineReducers({
  sector: sectorReducer,
  listado: listadoReducer
});
